












































































import AuthService from '@/services/auth-service'
import SnackbarService from '@/services/snackbar-service'
import { Component, Mixins, Watch } from 'vue-property-decorator'

@Component({
  components: {},
})
export default class RegistrateView extends Mixins(
  AuthService,
  SnackbarService
) {
  email = ''
  username = ''
  password = ''
  password2 = ''
  promoCode = ''
  acceptTermsAndConditions = false
  alreadyExistsError = {
    username: false,
    email: false,
  }
  alreadyExistsMessage = {
    username: '',
    email: '',
  }
  formValid = false

  checkingExists = false
  checkEmailTimeout: any
  showPasswordsEqualError = false
  passwordsNotEqualMessage = ''
  password1Blurred = false
  timeoutPassword1Blurred: any
  password2Blurred = false
  timeoutPassword2Blurred: any
  emailValidError = false
  emailValidMessage = ''
  password1StrongError = false
  password1StrongMessage = ''

  setTimeouts() {
    this.setTimeoutPassword1Blurred()
    this.setTimeoutPassword2Blurred()
  }

  setTimeoutPassword1Blurred() {
    this.password1Blurred = false
    clearTimeout(this.timeoutPassword1Blurred)
    if (this.password === '') {
      return
    }
    this.timeoutPassword1Blurred = setTimeout(() => {
      this.password1Blurred = true
      this.updateShowPassword1Error()
    }, 2000)
  }

  setTimeoutPassword2Blurred() {
    this.password2Blurred = false
    clearTimeout(this.timeoutPassword2Blurred)
    if (this.password === '' || this.password2 === '') {
      return
    }
    this.timeoutPassword2Blurred = setTimeout(() => {
      this.password2Blurred = true
      this.updateShowPassword2Error()
    }, 2000)
  }

  sendRegistration() {
    if (this.username === '' || this.password === '') {
      return
    }
    this.$store.state.loading = true
    this.registrate(this.email, this.username, this.password, this.promoCode)
      .then((res: any) => {
        this.$router.push('/login')
        this.notify({
          text: `We just sended you an email. Please open your email account and click on the verification link`,
          type: 'success',
          timeout: 20000,
        })
      })
      .catch((error: any) => {
        if (error.response.status === 400) {
          this.notify({
            type: 'warning',
            text: 'A user with this email address already exists'
          })
        }
      })
      .finally(() => {
        this.$store.state.loading = false
      })
  }

  checkIfExists(type: string) {
    this.checkingExists = true
    if (
      (type === 'username' && this.username === '') ||
      (type === 'email' && this.email === '')
    ) {
      this.alreadyExistsError[type] = false
      this.alreadyExistsMessage[type] = ''
      this.checkingExists = false
      return
    }
    clearTimeout(this.checkEmailTimeout)
    this.checkEmailTimeout = setTimeout(() => {
      const value: string = type === 'username' ? this.username : this.email
      if (type === 'email') {
        this.validateEmail()
        if (this.emailValidError) {
          return
        }
      }
      this.checkExists(type, value)
        .then(() => {
          this.alreadyExistsError[type] = false
          this.alreadyExistsMessage[type] = ''
        })
        .catch((error: any) => {
          if (error.response.status === 302) {
            this.alreadyExistsError[type] = true
            const message = `This ${type} already exists. Please use a different ${type}`
            this.alreadyExistsMessage[type] = message
          }
        })
        .finally(() => {
          this.updateformValid()
          this.checkingExists = false
        })
    }, 2000)
  }

  @Watch('password1Blurred')
  updateShowPassword1Error() {
    this.updateShowPassword1StrongError()
    this.updatePassword1StrongMessage()
  }

  updateShowPassword1StrongError() {
    this.password1StrongError =
      this.password1Blurred && this.password.length < 4
  }

  updatePassword1StrongMessage() {
    if (this.password1StrongError) {
      this.password1StrongMessage =
        'The password sould be at least 5 characters long'
    } else {
      this.password1StrongMessage = ''
    }
  }

  @Watch('password2Blurred')
  updateShowPassword2Error() {
    this.updateShowPasswordsEqualError()
    this.updatePasswordsNotEqualMessage()
  }

  updateShowPasswordsEqualError() {
    this.showPasswordsEqualError =
      this.password2Blurred && this.password !== this.password2
  }

  updatePasswordsNotEqualMessage() {
    if (this.showPasswordsEqualError) {
      this.passwordsNotEqualMessage = 'Passwords do not match'
    } else {
      this.passwordsNotEqualMessage = ''
    }
  }

  @Watch('email')
  @Watch('username')
  @Watch('password')
  @Watch('password2')
  updateformValid() {
    this.formValid =
      this.email !== '' &&
      this.username !== '' &&
      this.password !== '' &&
      this.password === this.password2 &&
      !this.alreadyExistsError.username &&
      !this.alreadyExistsError.email &&
      !this.emailValidError
  }

  validateEmail() {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    const valid = re.test(String(this.email).toLowerCase())
    if (valid) {
      this.emailValidError = false
      this.alreadyExistsMessage.email = ''
    } else {
      this.emailValidError = true
      this.alreadyExistsMessage.email = 'Please enter a valid email address'
    }
  }
}
